import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0eaf102e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "after-page" }
const _hoisted_2 = { class: "after-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/images/paysuccess.svg" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pay-title" }, "支付成功", -1))
const _hoisted_5 = { class: "pay-order" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.payMessage.orderName) + " " + _toDisplayString(_ctx.payMessage.orderNum), 1),
      _withDirectives(_createElementVNode("div", { class: "pay-amount" }, "￥" + _toDisplayString(_ctx.payMessage.amount), 513), [
        [_vShow, _ctx.payMessage.amount !== '']
      ]),
      _createElementVNode("button", {
        class: "after-pay-btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleComplete && _ctx.handleComplete(...args)))
      }, "完成")
    ])
  ]))
}